export const isInsideBounds = (point, bounds) => {
	const { nw, se } = bounds;
	const { lat, lng } = point;

	const isInside =
		nw.lat >= lat && se.lat <= lat && nw.lng <= lng && se.lng >= lng;

	return isInside;
};
